import React, { useState, useEffect } from "react";
import { useGlobal } from "../../global/user";
import { Button, Modal, Form, Input, List, message, Table, DatePicker, Tabs, Select, Tag } from "antd";
import { FcSettings, FcPortraitMode, FcSurvey } from "react-icons/fc";
import { EditOutlined, DeleteOutlined, PlusOutlined, UserAddOutlined, ReloadOutlined,} from "@ant-design/icons";
import Entrance from "../../api/Entrance";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

export default function Function13({ machineID }) {
  const { user } = useGlobal();
  const [settingsModal, setSettingsModal] = useState(false);
  const [peopleModal, setPeopleModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [devices, setDevices] = useState([]);
  const [deviceModal, setDeviceModal] = useState(false);
  const [currentDevice, setCurrentDevice] = useState(null);
  const [deviceForm] = Form.useForm();
  const [deviceGroups, setDeviceGroups] = useState([]);
  const [currentEstate, setCurrentEstate] = useState([]);
  
  // 歷史紀錄相關
  const [historyData, setHistoryData] = useState([]);
  const [strangersHistoryData, setStrangersHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState([dayjs(), dayjs()]);
  const [recordsTab, setRecordsTab] = useState("records");

  // 人員名冊相關
  const [personnelData, setPersonnelData] = useState([]);
  const [personnelLoading, setPersonnelLoading] = useState(false);
  const [personnelSearch, setPersonnelSearch] = useState("");
  const [personnelTotal, setPersonnelTotal] = useState(0);
  const [personnelPage, setPersonnelPage] = useState(1);

  // 編輯人員自訂欄位相關
  const [editPersonnelModal, setEditPersonnelModal] = useState(false);
  const [currentPersonnel, setCurrentPersonnel] = useState(null);
  const [editPersonnelForm] = Form.useForm();
  const [sameEstateDepartments, setSameEstateDepartments] = useState([]);
  const [photoBase64, setPhotoBase64] = useState(null);

  // 新增人員相關
  const [addPersonnelModal, setAddPersonnelModal] = useState(false);
  const [addPersonnelForm] = Form.useForm();
  const [allDepartments, setAllDepartments] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);

  //裝置下發相關
  const [sendDeviceModal, setSendDeviceModal] = useState(false);
  const [sentStatusMap, setSentStatusMap] = useState({});
  const [loadingId, setLoadingId] = useState(null);
  const [opLoading, setOpLoading] = useState({});

  // 即時影像相關
  const [currentScreenModal, setCurrentScreenModal] = useState(false);
  const [currentScreenImg, setCurrentScreenImg] = useState(null);
  const [isImgLoading, setIsImgLoading] = useState(false);

  useEffect(() => {
    loadEstate();
  }, []);

  useEffect(() => {
    if (currentEstate?.estate_id) {
      loadDevices(currentEstate.estate_id);
    }
  }, [currentEstate]);

  const loadDevices = async (estate_id) => {
    try {
      const data = await Entrance.getDevices(machineID, estate_id);
      setDevices(data);
    } catch (error) {
      console.error("載入設備失敗:", error);
    }
  }; 

  const loadEstate = async () => {
    try {
      const estate = await Entrance.getEstate(machineID);
      setCurrentEstate(estate.data);
    } catch (error) {
      console.error("載入場域失敗:", error);
    }
  };

  // 載入歷史紀錄
  const loadHistoryRecords = async () => {
    if (devices.length === 0) {
      message.warning("請先在設定中新增設備裝置號");
      setHistoryData([]);
      setHistoryLoading(false);
      return;
    }

    setHistoryLoading(true);
    try {
      let data = await Entrance.getRecords(machineID, {
        start_date: dateRange[0].format('YYYY-MM-DD'),
        end_date: dateRange[1].format('YYYY-MM-DD'),
        keywords: searchText,
      });
      
      if (data.message && data.total === 0) {
        message.info(data.message);
      }

      data.records = data.records.map(item => ({
        ...item,
        age: birthdayToAge(item.birth_date)
      }));

      setHistoryData(data.records || []);
    } catch (error) {
      message.error("載入紀錄失敗");
      console.error(error);
    } finally {
      setHistoryLoading(false);
    }
  };

  //載入陌生紀錄
  const loadStrangersRecords = async () => {
    if (devices.length === 0) {
      message.warning("請先在設定中新增設備裝置號");
      setStrangersHistoryData([]);
      setHistoryLoading(false);
      return;
    }

    setHistoryLoading(true);
    try {
      const strangers_data = await Entrance.getStrangers(machineID, {
        start_date: dateRange[0].format('YYYY-MM-DD'),
        end_date: dateRange[1].format('YYYY-MM-DD'),
        keywords: searchText,
      });

      if (strangers_data.message && strangers_data.total === 0) {
        message.info(strangers_data.message);
      }

      setStrangersHistoryData(strangers_data.list || []);
    } catch (error) {
      message.error("載入陌生人紀錄失敗");
      console.error(error);
    } finally {
      setHistoryLoading(false);
    }
  };

  // 切換歷史記錄頁籤
  const handleHistoryTabChange = (key) => {
    setRecordsTab(key);
    
    if (key === 'records') {
      loadHistoryRecords();
    } else if (key === 'Stranger') {
      loadStrangersRecords();
    }
  };

  // 轉換年齡
  const birthdayToAge = (birth_date) => {
    if (!birth_date) return "-";
    const birth = new Date(birth_date);
    const today = new Date();

    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();

    if (months < 0 || (months === 0 && today.getDate() < birth.getDate())) {
      years--;
      months += 12;
    }

    if (today.getDate() < birth.getDate() && months > 0) {
      months--;
    }

    return `${years} 歲 ${months} 個月`;
  };

  // 載入人員名冊
  const loadPersonnel = async (page = 1, keywords = "") => {
    if (devices.length === 0) {
      message.warning("請先在設定中新增設備裝置號");
      setPersonnelData([]);
      setPersonnelTotal(0);
      setPersonnelLoading(false);
      return;
    }

    setPersonnelLoading(true);
    try {
      await Entrance.getPersonnel(currentEstate.estate_id, machineID);
      let local_data = await Entrance.getLocalPersonnel(machineID, {
        page: page,
        limit: 10,
        keywords: keywords,
      });

      local_data.list = local_data.list.map(item => ({
        ...item,
        photo: item.photo_url || item.photo,
        age: birthdayToAge(item.birth_date)
      }));
      console.log("local_data", local_data);
      setPersonnelData(local_data.list || []);
      setPersonnelTotal(local_data.dataCount || local_data.total || 0);
    } catch (error) {
      message.error("載入人員名冊失敗");
      console.error(error);
    } finally {
      setPersonnelLoading(false);
    }
  };

  // 取得同一專案下部門列表
  const get_same_departments = async (current_department_name) => {
    try {
      const response = await Entrance.getDepartments();
      const allDepartments = Array.isArray(response) ? response : []; 
      const currentDept = allDepartments.find(dept => dept.department_name === current_department_name);
      if (!currentDept) return [];

      const sameDepartments = allDepartments.filter(
        dept => dept?.estate_id === currentDept.estate_id
      );
      setSameEstateDepartments(sameDepartments);
      return sameDepartments.reduce((acc, dept) => {
            acc[dept.department_name] = dept.department_id;
            return acc;
          }, {});
    } catch (error) {
      setSameEstateDepartments([]);
      return [];
    }
  };

  // 打開歷史紀錄Modal
  const handleOpenHistory = async () => {
    setHistoryModal(true);
    await loadDevices();
    await loadHistoryRecords();
    await loadStrangersRecords();
  };

  // 打開人員名冊Modal
  const handleOpenPeople = async () => {
    setPeopleModal(true);
    setPersonnelPage(1);
    await loadDevices(currentEstate.estate_id);
    await loadPersonnel(1, personnelSearch);
  };

  // 人員搜尋
  const handlePersonnelSearch = (value) => {
    setPersonnelSearch(value);
    setPersonnelPage(1);
    loadPersonnel(1, value);
  };

  // 人員分頁變更
  const handlePersonnelPageChange = (page) => {
    setPersonnelPage(page);
    loadPersonnel(page, personnelSearch);
  };

  // 打開編輯人員自訂欄位Modal
  const handleEditPersonnel = async (person) => {
    setPhotoBase64(null);
    setCurrentPersonnel(person);
    const department_nameToId_map = await get_same_departments(person.department_name);

    editPersonnelForm.setFieldsValue({
      id_name: person.id_name || undefined,
      department: {
        value: department_nameToId_map[person.department_name] || undefined, 
        label: person.department_name,
      },
      job_title: person.job_title || undefined,
      phone: person.phone || undefined,
      blood_type: person.blood_type || undefined,
      gender: person.gender || undefined,
      birth_date: person.birth_date ? dayjs(person.birth_date) : undefined,
      notes: person.notes || undefined,
    });
    
    setEditPersonnelModal(true);
  };
  
  // 提交編輯人員自訂欄位
  const handleEditPersonnelSubmit = async (values) => {
    try {
      const submitData = {
        ...values,
        birth_date: values.birth_date ? values.birth_date.format('YYYY-MM-DD') : null,
        ...((photoBase64 || (photoBase64 === '')) && { photo: photoBase64 }),
      };

      console.log(submitData);
      const result = await Entrance.updatePersonnelCustomFields(currentPersonnel.user_id, submitData);
      if (result.message === 'Success' || result.message === 'Personnel updated successfully') message.success("更新成功");
      else {
        message.error(result.message);
      }
      setEditPersonnelModal(false);
      editPersonnelForm.resetFields();
      
      // 重新載入資料
      loadPersonnel(personnelPage, personnelSearch, "local");
      setPhotoBase64(currentPersonnel.photo);

    } catch (error) {
      message.error("更新失敗");
      console.error(error);
    }
  };

  // 處理照片上傳
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 檢查檔案類型
    const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!validImageTypes.includes(file.type)) {
      message.error('請上傳有效的圖片檔案 (JPG, PNG)');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      message.error('照片大小不能超過 5MB');
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const base64String = event.target.result;
      setPhotoBase64(base64String);
    };
    reader.onerror = () => {
      message.error('讀取照片失敗');
    };
    reader.readAsDataURL(file);
  };

  // 刪除人員
  const handleDeletePersonnel = (personnelID) => {
    Modal.confirm({
      title: "確認刪除",
      content: "確定要刪除此人員嗎?",
      onOk: async () => {
        try {
          await Entrance.deletePersonnel(personnelID);
          message.success("人員已刪除");
          loadPersonnel(personnelPage, personnelSearch, "local");
        } catch (error) {
          message.error("刪除失敗");
          console.error(error);
        }
      },
    });
  };

  // 打開新增人員自訂欄位Modal
  const handleAddPersonnel = async () => {
    setPhotoBase64(null);
    setAllDepartments([]);
    setCurrentPersonnel(null);

    const departments = await Entrance.getDepartments();
    const allDepartments = departments.filter(
      dept => dept.estate_id === currentEstate.estate_id
    );
    setAllDepartments(allDepartments);
    

    setAddPersonnelModal(true);
  };

  // 提交新增人員
  const handleAddPersonnelSubmit = async (values) => {
    try {
      // 轉換日期格式
      const submitData = {
        ...values,
        birth_date: values.birth_date ? values.birth_date.format('YYYY-MM-DD') : null,
        photo: photoBase64 || '',
        estate: currentEstate.estate_id || null,
        department: values.department ? values.department.value : null,
      };

      const result = await Entrance.addPersonnel(machineID, submitData);
      if (result.message === 'Success' || result.message === 'Personnel add successfully') message.success("新增成功");
      else {
        message.error(result.message);
      }
      setAddPersonnelModal(false);
      
      // 重新載入資料
      loadPersonnel(personnelPage, personnelSearch, "local");
      setPhotoBase64('');

    } catch (error) {
      message.error("新增失敗");
      console.error(error);
    }
  };

  // 載入裝置組列表
  const loadDeviceGroups = async () => {
    try {
      const groups = await Entrance.getDevicesGroup();
      const targetEstateId = currentEstate?.estate_id;

      const filteredGroups = (groups?.list || [])
        .filter(item => item.estate_id === targetEstateId)
        .map(item => ({
          id: item.device_g_id,
          name: item.device_g_name
        }));

      setDeviceGroups(filteredGroups);
    } catch (error) {
      console.error("Error fetching device groups:", error);
    }
  };

  // 新增設備
  const handleAddDevice = () => {
    setCurrentDevice(null);
    loadDeviceGroups();
    deviceForm.resetFields();
    setDeviceModal(true);
  };

  // 編輯設備
  const handleEditDevice = (device) => {
    setCurrentDevice(device);
    deviceForm.setFieldsValue(device);
    setDeviceModal(true);
  };

  // 提交設備表單
  const handleDeviceSubmit = async (values) => {
    try {
      if (currentDevice) {
        await Entrance.updateDevice(currentDevice.id, values);
        message.success("設備已更新");
      } else {
        await Entrance.addDevice(machineID, values);
        message.success("設備已新增");
      }
      setDeviceModal(false);
      deviceForm.resetFields();
      loadDevices();
    } catch (error) {
      message.error("操作失敗");
      console.error(error);
    }
  };

  // 刪除設備
  const handleDeleteDevice = (id) => {
    Modal.confirm({
      title: "確認刪除",
      content: "確定要刪除此設備嗎?",
      onOk: async () => {
        try {
          await Entrance.deleteDevice(id);
          message.success("設備已刪除");
          loadDevices();
        } catch (error) {
          message.error("刪除失敗");
          console.error(error);
        }
      },
    });
  };

  // 設備開門
  const handleOpenDoor = (device) => {

    Modal.confirm({
      title: "確認開門",
      content: "確定要開門嗎?",
      onOk: async () => {
        try {
          await Entrance.openDoor(device.device_sn);
          message.success("已開門");
          loadDevices();
        } catch (error) {
          message.error("開門失敗");
          console.error(error);
        }
      },
    });
  };

  // 打開即時影像modal
  const handleCurrentScreenModal = async (device) => {
    try {
      setIsImgLoading(true);
      setCurrentDevice(device);
      getCurrentScreen(device);
      setCurrentScreenModal(true);
    } catch (error) {
      message.error("失敗");
      console.error(error);
    } finally {
    setIsImgLoading(false);
    }
  };

  const getCurrentScreen = async (device) => {
    try{
      setIsImgLoading(true);
      const resultImg = (await Entrance.currentScreen(device.device_sn)).img;
      const currentScreenBase64 = `data:image/jpeg;base64,${resultImg}`;
      setCurrentScreenImg(currentScreenBase64);
    } catch (error) {
      message.error("失敗");
      console.error(error);
    } finally {
      setIsImgLoading(false);
    }
  };
// ================================= 下發相關 =================================

  // 打開下發modal
  const handleSendDevice = async (person) => {
    setLoadingId(person.user_id);
    try {
      setCurrentPersonnel(person);
      const data = {
        user_id: person.user_id,
        device_sns: devices.map(item => item.device_sn)
      };
      const res = await Entrance.getSentDevice(data);
      setSentStatusMap(res.data);
      setSendDeviceModal(true);
    } catch (error) {
      message.error("獲取狀態失敗");
    } finally {
      setLoadingId(null);
    }
  };

  // 下發使用者
  const sendToDevice = async (person, sn) => {
    updateLoading(sn, 'add', true);
    try {
      const res = await Entrance.sendToDevice({ user_id: person.user_id, device_sn: sn });
      if (res.code === 200) {
        message.success("新增成功");
        setSentStatusMap(prev => ({ ...prev, [sn]: true }));
      } else {
        message.error(res.msg);
      }
    } catch (error) {
      message.error("系統異常");
    } finally {
      updateLoading(sn, 'add', false);
    }
  };

  // 刪除使用者
  const deleteUserInDevice = async (person, sn) => {
    updateLoading(sn, 'del', true);
    try {
      const res = await Entrance.deleteUserInDevice({ user_id: person.user_id, device_sn: sn });
      if (res.code === 200) {
        message.success("刪除成功");
        setSentStatusMap(prev => ({ ...prev, [sn]: false }));
      } else {
        message.error(res.msg);
      }
    } catch (error) {
      message.error("系統異常");
    } finally {
      updateLoading(sn, 'del', false);
    }
  };

  const updateLoading = (sn, action, isLoading) => {
    setOpLoading(prev => ({
      ...prev,
      [`${sn}_${action}`]: isLoading
    }));
  };

  // 歷史紀錄表格欄位
  const historyColumns = [
    {
      title: "時間",
      dataIndex: "recog_time",
      key: "recog_time",
      width: 180,
    },
    {
      title: "姓名",
      dataIndex: "user_name",
      key: "user_name",
      width: 120,
    },
    {
      title: "影像紀錄",
      dataIndex: "photo_url",
      key: "photo_url",
      width: 100,
      render: (photo_url) => (
        photo_url ? (
          <Button
            type="link"
            size="small"
            onClick={() => {
              Modal.info({
                title: "進出影像",
                width: 600,
                content: (
                  <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <img 
                      src={photo_url} 
                      alt="進出影像" 
                      style={{ maxWidth: '100%', maxHeight: '500px' }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/300x400?text=無影像';
                      }}
                    />
                  </div>
                ),
              });
            }}
          >
            查看
          </Button>
        ) : (
          <span style={{ color: '#999' }}>無影像</span>
        )
      ),
    },
    {
      title: "設備名稱",
      dataIndex: "device_name",
      key: "device_name",
      width: 150,
    },
    {
      title: "設備號",
      dataIndex: "device_sn",
      key: "device_sn",
      width: 120,
    },
    {
      title: "部門",
      dataIndex: "department_name",
      key: "department_name",
      width: 150,
    },
    {
      title: "職稱",
      dataIndex: "job_title", 
      key: "job_title",
      width: 120,
      render: (job_title) => job_title || "-",
    },
    {
      title: "電話",
      dataIndex: "phone",
      key: "phone",
      width: 120,
      render: (phone) => phone || "-",
    },
    {
      title: "血型",
      dataIndex: "blood_type",
      key: "blood_type",
      width: 80,
      render: (blood_type) => blood_type || "-",
    },
    {
      title: "性別",
      dataIndex: "gender",
      key: "gender",
      width: 80,
      render: (gender) => gender || "-",
    },
    {
      title: "年齡",
      dataIndex: "age",
      key: "age",
      width: 120,
      render: (age) => age || "-",
    },
  ];

  // 陌生人紀錄表格欄位
  const strangersHistoryColumns = [
    {
      title: "時間",
      dataIndex: "recog_time",
      key: "recog_time",
      width: 180,
    },
    {
      title: "影像紀錄",
      dataIndex: "photo_url",
      key: "photo_url",
      width: 100,
      render: (photo_url) => (
        photo_url ? (
          <Button
            type="link"
            size="small"
            onClick={() => {
              Modal.info({
                title: "進出影像",
                width: 600,
                content: (
                  <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <img 
                      src={photo_url} 
                      alt="進出影像" 
                      style={{ maxWidth: '100%', maxHeight: '500px' }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/300x400?text=無影像';
                      }}
                    />
                  </div>
                ),
              });
            }}
          >
            查看
          </Button>
        ) : (
          <span style={{ color: '#999' }}>無影像</span>
        )
      ),
    },
    {
      title: "設備名稱",
      dataIndex: "device_name",
      key: "device_name",
      width: 150,
    },
    {
      title: "設備號",
      dataIndex: "device_sn",
      key: "device_sn",
      width: 120,
    },
  ];

   // 人員名冊表格欄位（門禁系統）
  const personnelRemoteColumns = [
    {
      title: "照片",
      dataIndex: "photo",
      key: "photo",
      width: 80,
      render: (photo) => (
        photo ? (
          <img
            src={photo}
            alt="人員照片"
            style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
          />
        ) : (
          <div style={{ width: "50px", height: "50px", background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px" }}>
            無
          </div>
        )
      ),
    },
    {
      title: "姓名",
      dataIndex: "id_name",
      key: "id_name",
      width: 120,
    },
    {
      title: "工號",
      dataIndex: "work_sn",
      key: "work_sn",
      width: 120,
      render: (work_sn) => work_sn || "-",
    },
    {
      title: "部門",
      dataIndex: "department_name",
      key: "department_name",
      width: 150,
    },
    {
      title: "下發裝置",
      dataIndex: "device_sn",
      key: "device_sn",
      width: 120,
      render: (_, record) => (
          <Button
            type="link"
            size="small"
            icon={<UserAddOutlined />}
            loading={loadingId === record.user_id} 
            onClick={() => handleSendDevice(record)}
          >
            設定
          </Button>
        ),
    },
    {
      title: "職稱",
      dataIndex: "job_title",
      key: "job_title",
      width: 120,
      render: (job_title) => job_title || "-",
    },
    {
      title: "電話",
      dataIndex: "phone",
      key: "phone",
      width: 120,
      render: (phone) => phone || "-",
    },
  ];

  // 人員名冊表格欄位（本地DB，含自訂欄位）
  const personnelLocalColumns = [
    ...personnelRemoteColumns,
    {
      title: "血型",
      dataIndex: "blood_type",
      key: "blood_type",
      width: 80,
      render: (blood_type) => blood_type || "-",
    },
    {
      title: "性別",
      dataIndex: "gender",
      key: "gender",
      width: 80,
      render: (gender) => gender || "-",
    },
    {
      title: "年齡",
      dataIndex: "age",
      key: "age",
      width: 120,
      render: (age) => age || "-",
    },
    {
      title: "操作",
      key: "action",
      width: 100,
      render: (_, record) => (
        <>
          <Button
            type="link"
            size="small"
            icon={<EditOutlined />}
            onClick={() => handleEditPersonnel(record)}
          >
            編輯
          </Button>
          <Button
            type="link"
            size="small"
            icon={<DeleteOutlined />}
            onClick={() => handleDeletePersonnel(record.id)}
          >
            刪除
          </Button>
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center py-2">
          <div style={{ width: "60%" }}>
            <div className="d-flex justify-content-center" style={{ marginBottom: "15px" }}>
              <span>機具編號:</span>
              <span>{machineID}</span>
            </div>

            <div className="d-flex justify-content-center">
              {user.class >= process.env.REACT_APP_EDITOR_CALSS_LV && (
                <>
                  <Button
                    shape="circle"
                    className="mr-2"
                    icon={<FcSettings style={{ fontSize: "20px" }} />}
                    onClick={() => {
                      loadDevices();
                      setSettingsModal(true);
                    }}
                  />
                  <Button
                    shape="circle"
                    className="mr-2"
                    icon={<FcPortraitMode style={{ fontSize: "20px" }} />}
                    onClick={handleOpenPeople}
                  />
                  <Button
                    shape="circle"
                    icon={<FcSurvey style={{ fontSize: "20px" }} />}
                    onClick={handleOpenHistory}
                  />
                </>
              )}
            </div>
          </div>
        </div>

        {/* 設定 Modal */}
        <Modal
          title="設備管理"
          open={settingsModal}
          onCancel={() => setSettingsModal(false)}
          footer={null}
          width={700}
        >
          <Button
            type="primary"
            onClick={handleAddDevice}
            style={{ marginBottom: "20px" }}
          >
            新增設備
          </Button>

          <List
            bordered
            dataSource={devices}
            renderItem={(device) => (
              <List.Item
                actions={[
                  <Button
                    key="current_screen"
                    type="text"
                    onClick={() => handleCurrentScreenModal(device)}
                    disabled={!device.is_online}
                    style={{
                      opacity: !device.is_online ? 0.5 : 1 
                    }}                  >
                    現場畫面
                  </Button>,
                  <Button
                    key="open"
                    type="text"
                    onClick={() => handleOpenDoor(device)}
                    disabled={!device.is_online}
                    style={{ 
                      opacity: !device.is_online ? 0.5 : 1 
                    }}                  >
                    遠端開門
                  </Button>,
                  <Button key="edit" type="text" shape="circle" size="small" onClick={() => handleEditDevice(device)} icon={<EditOutlined />} title="編輯"/>,
                  <Button key="delete" type="text" shape="circle" size="small" onClick={() => handleDeleteDevice(device.id)} icon={<DeleteOutlined />} title="刪除"/>
                ]}
              >
                <div>
                  <div>
                    <b>設備名稱:</b> {device.name}
                  </div>
                  <div>
                    <b>設備裝置號:</b> {device.device_sn}
                    {device.is_online ? (
                        <Tag color="success" style={{ marginLeft: 8 }}>上線</Tag>
                      ) : (
                        <Tag color="default" style={{ marginLeft: 8 }}>離線</Tag>
                    )}
                  </div>
                </div>
              </List.Item>
            )}
          />
        </Modal>

        {/* 設備新增/編輯 Modal */}
        <Modal
          title={currentDevice ? "編輯設備" : "新增設備"}
          open={deviceModal}
          onCancel={() => {
            setDeviceModal(false);
            deviceForm.resetFields();
          }}
          onOk={() => deviceForm.submit()}
          okText="確定"
          cancelText="取消"
        >
          <Form
            form={deviceForm}
            layout="vertical"
            onFinish={handleDeviceSubmit}
          >
            <Form.Item
              label="設備名稱"
              name="name"
              rules={[{ required: true, message: "請輸入設備名稱" }]}
            >
              <Input placeholder="例如:岡山局限入口" />
            </Form.Item>

            <Form.Item
              label="設備裝置號"
              name="device_sn"
              rules={[{ required: true, message: "請輸入設備裝置號" }]}
            >
              <Input placeholder="例如:YT88914" />
            </Form.Item>
          </Form>
        </Modal>

        {/* 人員名冊 Modal */}
        <Modal
          title="人員名冊"
          open={peopleModal}
          onCancel={() => setPeopleModal(false)}
          footer={null}
          width={1400}
        >
          {devices.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
              <p style={{ fontSize: '16px', marginBottom: '10px' }}>尚未設定設備裝置號</p>
              <p>請先在「設定」中新增設備,才能查看人員名冊</p>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: "20px", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <div>
                  <Input.Search
                    placeholder="搜尋姓名、工號或部門"
                    onSearch={handlePersonnelSearch}
                    style={{ width: 300 }}
                    allowClear
                  />
                </div>
                
                <Button 
                  type="primary" 
                  icon={<PlusOutlined />}
                  onClick={() => {
                    handleAddPersonnel();
                  }}
                >
                  新增人員
                </Button>
              </div>
              <Table
                columns={personnelLocalColumns}
                dataSource={personnelData}
                loading={personnelLoading}
                rowKey="id"
                pagination={{
                  current: personnelPage,
                  pageSize: 10,
                  total: personnelTotal,
                  onChange: handlePersonnelPageChange,
                  showTotal: (total) => `共 ${total} 位人員`,
                }}
                scroll={{ y: 500 }}
                locale={{
                  emptyText: '暫無人員資料'
                }}
              />
            </>
          )}
        </Modal>

        {/* 編輯人員自訂欄位 Modal */}
        <Modal
          title={`編輯人員資料 - ${currentPersonnel?.id_name || ''}`}
          open={editPersonnelModal}
          confirmLoading={confirmLoading}
          onCancel={() => {
            if (confirmLoading) return;
            setPhotoBase64(null);
            setEditPersonnelModal(false);
            editPersonnelForm.resetFields();
          }}
          onOk={() => {
            editPersonnelForm.submit();
          }}
          okText="儲存"
          cancelText="取消"
          width={600}
        >
          <Form
            form={editPersonnelForm}
            layout="vertical"
            onFinish={async(values) => {
              setConfirmLoading(true);
              await handleEditPersonnelSubmit(values);
              setConfirmLoading(false);
            }}
          >
            <Form.Item 
              label='照片'
              name='photo'
            >
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
                {(photoBase64 || currentPersonnel?.photo) && photoBase64 !== '' ? (
                  <img
                    src={photoBase64 || currentPersonnel.photo}
                    alt="人員照片"
                    style={{ 
                      width: "120px", 
                      height: "160px", 
                      objectFit: "cover", 
                      borderRadius: "4px" 
                    }}
                  />
                ) : (
                  <div style={{ 
                    width: "120px", 
                    height: "160px", 
                    background: "#f0f0f0", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    borderRadius: "4px" 
                  }}>
                    無
                  </div>
                )}
                
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="photo-upload"
                  onChange={handlePhotoChange}
                />

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <Button 
                    type="primary"
                    onClick={() => document.getElementById('photo-upload').click()}
                  >
                    更換照片
                  </Button>
                  <Button
                    danger
                    onClick={() => setPhotoBase64('')}
                  >
                    移除照片
                  </Button>
                </div>
              </div>
            </Form.Item>


            <Form.Item
              label="姓名"
              name="id_name"
            >
              <TextArea 
                rows={1} 
                placeholder="請輸入姓名"
                maxLength={100}
                showCount
              />
            </Form.Item>

            <Form.Item
              label="部門"
              name="department"
            >
              <Select 
                placeholder="請選擇部門" 
                allowClear
                labelInValue
              >
                {sameEstateDepartments.map(dept => (
                  <Option key={dept.department_id} value={dept.department_id}>
                    {dept.department_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="職稱"
              name="job_title"
            >
              <Input placeholder="請輸入職稱"/>
            </Form.Item>

            <Form.Item
              label="電話"
              name="phone"
              rules={[
                { pattern: /^[0-9+-\s#]*$/, message: '請輸入有效的電話格式' },
                { max: 20, message: '電話長度超出限制' }
              ]}
            >
              <Input placeholder="請輸入電話"/>
            </Form.Item>

            <Form.Item
              label="血型"
              name="blood_type"
            >
              <Select placeholder="請選擇血型" allowClear>
                <Option value="A">A型</Option>
                <Option value="B">B型</Option>
                <Option value="AB">AB型</Option>
                <Option value="O">O型</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="性別"
              name="gender"
            >
              <Select placeholder="請選擇性別" allowClear>
                <Option value="男">男</Option>
                <Option value="女">女</Option>
                <Option value="其他">其他</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="生日"
              name="birth_date"
            >
              <DatePicker 
                placeholder="請選擇生日" 
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
              />
            </Form.Item>

            <Form.Item
              label="備註"
              name="notes"
            >
              <TextArea 
                rows={4} 
                placeholder="請輸入備註資訊"
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Form>
        </Modal>

        {/* 新增人員 Modal */}
        <Modal
          title="新增人員"
          open={addPersonnelModal}
          confirmLoading={confirmLoading}
          onCancel={() => {
            if (confirmLoading) return;
            setPhotoBase64(null);
            setAddPersonnelModal(false);
            addPersonnelForm.resetFields();
          }}
          onOk={() => {
            addPersonnelForm.submit();
          }}
          okText="新增"
          cancelText="取消"
        >
          <Form
            form={addPersonnelForm}
            layout="vertical"
            onFinish={async (values) => {
              setConfirmLoading(true);
              try {
                await handleAddPersonnelSubmit(values); 
                setAddPersonnelModal(false);
                addPersonnelForm.resetFields();
              } catch (error) {
                console.error("提交失敗", error);
              } finally {
                setConfirmLoading(false);
              }
            }}
          >
            <Form.Item label='照片'>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
                {photoBase64 && photoBase64 !== '' ? (
                  <img
                    src={photoBase64}
                    alt="人員照片"
                    style={{ 
                      width: "120px", 
                      height: "160px", 
                      objectFit: "cover", 
                      borderRadius: "4px" 
                    }}
                  />
                ) : (
                  <div style={{ 
                    width: "120px", 
                    height: "160px", 
                    background: "#f0f0f0", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    borderRadius: "4px" 
                  }}>
                    無
                  </div>
                )}
                
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="photo-upload-add"
                  onChange={handlePhotoChange}
                />

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <Button 
                    type="primary"
                    onClick={() => document.getElementById('photo-upload-add').click()}
                  >
                    上傳照片
                  </Button>
                  <Button
                    danger
                    onClick={() => {
                      setPhotoBase64('');
                      const fileInput = document.getElementById('photo-upload-add');
                      if (fileInput) fileInput.value = '';
                    }}
                  >
                    移除照片
                  </Button>
                </div>
              </div>
            </Form.Item>

            <Form.Item
              label="姓名"
              name="id_name"
              rules={[{ required: true, message: '請輸入姓名' }]}
            >
              <Input 
                placeholder="請輸入姓名"
                maxLength={100}
                showCount
              />
            </Form.Item>

            <Form.Item
              label="部門"
              name="department"
              rules={[{ required: true, message: '請選擇部門' }]}
            >
              <Select 
                placeholder="請選擇部門" 
                allowClear
                labelInValue
              >
                {allDepartments.map(dept => (
                  <Option key={dept.department_id} value={dept.department_id}>
                    {dept.department_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="職稱"
              name="job_title"
            >
              <Input placeholder="請輸入職稱"/>
            </Form.Item>

            <Form.Item
              label="電話"
              name="phone"
              rules={[
                { pattern: /^[0-9+-\s#]*$/, message: '請輸入有效的電話格式' },
                { max: 20, message: '電話長度超出限制' }
              ]}
            >
              <Input placeholder="請輸入電話"/>
            </Form.Item>

            <Form.Item
              label="血型"
              name="blood_type"
            >
              <Select placeholder="請選擇血型" allowClear>
                <Option value="A">A型</Option>
                <Option value="B">B型</Option>
                <Option value="AB">AB型</Option>
                <Option value="O">O型</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="性別"
              name="gender"
            >
              <Select placeholder="請選擇性別" allowClear>
                <Option value="男">男</Option>
                <Option value="女">女</Option>
                <Option value="其他">其他</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="生日"
              name="birth_date"
            >
              <DatePicker 
                placeholder="請選擇生日" 
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
              />
            </Form.Item>

            <Form.Item
              label="備註"
              name="notes"
            >
              <TextArea 
                rows={4} 
                placeholder="請輸入備註資訊"
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Form>
        </Modal>

        {/* 歷史紀錄 Modal */}
        <Modal
          title="進出歷史紀錄"
          open={historyModal}
          onCancel={() => setHistoryModal(false)}
          footer={null}
          width={1200}
        >
          {devices.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
              <p style={{ fontSize: '16px', marginBottom: '10px' }}>尚未設定設備裝置號</p>
              <p>請先在「設定」中新增設備,才能查看進出紀錄</p>
            </div>
          ) : (
            <Tabs 
              activeKey={recordsTab} 
              onChange={handleHistoryTabChange}
              items={[
                {
                  key: 'records',
                  label: '識別記錄',
                  children: (
                    <>
                      <div style={{ marginBottom: "20px" }}>
                        <Input.Search
                          placeholder="搜尋姓名或關鍵字"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          onSearch={loadHistoryRecords}
                          style={{ width: 300, marginRight: "10px" }}
                        />
                        <RangePicker
                          value={dateRange}
                          onChange={(dates) => setDateRange(dates)}
                          format="YYYY-MM-DD"
                          style={{ marginRight: "10px" }}
                        />
                        <Button type="primary" onClick={loadHistoryRecords}>
                          查詢
                        </Button>
                      </div>

                      <Table
                        columns={historyColumns}
                        dataSource={historyData}
                        loading={historyLoading}
                        rowKey="id"
                        pagination={{
                          pageSize: 10,
                          showTotal: (total) => `共 ${total} 筆記錄`,
                        }}
                        scroll={{ y: 500 }}
                        locale={{
                          emptyText: '暫無進出紀錄'
                        }}
                      />
                    </>
                  ),
                },
                {
                  key: 'stranger',
                  label: '陌生紀錄',
                  children: (
                    <>
                      <div style={{ marginBottom: "20px" }}>
                        <Input.Search
                          placeholder="搜尋姓名或關鍵字"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          onSearch={loadStrangersRecords}
                          style={{ width: 300, marginRight: "10px" }}
                        />
                        <RangePicker
                          value={dateRange}
                          onChange={(dates) => setDateRange(dates)}
                          format="YYYY-MM-DD"
                          style={{ marginRight: "10px" }}
                        />
                        <Button type="primary" onClick={loadStrangersRecords}>
                          查詢
                        </Button>
                      </div>

                      <Table
                        columns={strangersHistoryColumns}
                        dataSource={strangersHistoryData}
                        loading={historyLoading}
                        rowKey="id"
                        pagination={{
                          pageSize: 10,
                          showTotal: (total) => `共 ${total} 筆記錄`,
                        }}
                        scroll={{ y: 500 }}
                        locale={{
                          emptyText: '暫無進出紀錄'
                        }}
                      />
                    </>
                  ),
                },
              ]}
            />
          )}
        </Modal>

        {/* 下發 Modal */}
        <Modal
          title={`人員下發管理 - ${currentPersonnel?.id_name || ''}`}
          open={sendDeviceModal}
          onCancel={() => setSendDeviceModal(false)}
          footer={null}
          width={700}
        >
          <List
            bordered
            dataSource={devices}
            renderItem={(device) => {
              const isAdding = opLoading[`${device.device_sn}_add`];
              const isDeleting = opLoading[`${device.device_sn}_del`];
              const isSent = !!sentStatusMap[device.device_sn];

              return (
                <List.Item
                  actions={[
                    <Button
                      key="edit"
                      type="primary"
                      style={{
                        width: '80px',
                        textAlign: 'left',
                        opacity: (isSent) ? 0.5 : 1,
                      }}
                      loading={isAdding}
                      disabled={isSent || isDeleting}
                      onClick={() => sendToDevice(currentPersonnel, device.device_sn)}
                    >
                      {isSent ? "已加入" : "待加入"}
                    </Button>,
                    <Button
                      key="delete"
                      danger
                      type="primary"
                      style={{
                        width: '80px',
                        textAlign: 'left',
                        opacity: (!isSent) ? 0.5 : 1,
                      }}
                      loading={isDeleting}
                      disabled={!isSent || isAdding}
                      onClick={() => deleteUserInDevice(currentPersonnel, device.device_sn)}
                    >
                      移除
                    </Button>,
                  ]}
                >
                  <List.Item.Meta
                    title={device.name}
                    description={
                      <span>
                        裝置號: {device.device_sn}
                        {isSent ? (
                          <Tag color="success" style={{ marginLeft: 8 }}>已下發</Tag>
                        ) : (
                          <Tag color="default" style={{ marginLeft: 8 }}>待下發</Tag>
                        )}
                      </span>
                    }
                  />
                </List.Item>
              );
            }}
          />
        </Modal>

        {/* 即時影像 Modal */}
        <Modal
          title={`即時影像 - ${currentDevice?.name || ''}`}
          open={currentScreenModal}
          onCancel={() => {
            setCurrentScreenModal(false);
            setCurrentScreenImg(null);
          }}
          footer={[
            <Button 
              key="update" 
              onClick={() => getCurrentScreen(currentDevice)}
              icon={<ReloadOutlined />}
              loading={isImgLoading}
            >
              更新
            </Button>,
            <Button 
              key="close" 
              onClick={() => setCurrentScreenModal(false)}
            >
              關閉
            </Button>
          ]}
          width={600}
        >
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            {currentScreenImg ? (
              <img
                src={currentScreenImg}
                alt="即時影像"
                style={{ maxWidth: '100%', maxHeight: '500px' }}
              />
            ) : (
              <div style={{ width: '100%', height: '500px', background: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ color: '#999' }}>載入中...</span>
              </div>
            )}
          </div>
        </Modal>
      </td>
    </React.Fragment>
  );
}